import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Button, Modal, Form } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import { getStoredUserId } from "./organizationStorage";
import { performLogout } from "../utils/sessionManager";
import { supportUrl } from "../constants/appRoutes";
import PartnerBusinessSwitcher from "../partner/PartnerBusinessSwitcher";
import "../admin/EatsAdminLayout.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/header.css";
import "./css/dashboard.css";
import organizationLogo from "./assets/business-os-logo.png";
import {
  getPasswordValidationErrors,
  extractPasswordErrorsFromResponse,
  PasswordErrorsDisplay,
} from "./passwordValidation";

const Organization = ({ isAuthenticated, setIsAuthenticated }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return; 

    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("Token");
        const user_id = getStoredUserId();

        if (!token || !user_id) {
          console.warn("No token or user ID found");
          return;
        }

        const response = await axiosOrganizationInstance.get(
          `/organization/user/${user_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setUserDetails({
          name: response.data.name,
          email: response.data.email,
        });
      } catch (error) {
        console.error(
          "Error fetching user details:",
          error.response?.data || error.message
        );
      }
    };

    fetchUserDetails();
  }, [isAuthenticated]); 

  const location = useLocation();

  const handleLogout = () => {
    setIsAuthenticated(false);
    performLogout({ redirectPath: "/partner/login" });
  };

  const isSupportPage = location.pathname === "/eats/support";

  // Header Component
  const Header = ({ isAuthenticated, onLogout, showLinks }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [error, setError] = useState("");
    const [passwordErrors, setPasswordErrors] = useState([]);

    const handleShow = () => setShow(true);
    const handleClose = () => {
      setShow(false);
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setError("");
      setPasswordErrors([]);
    };

    const handleUpdatePassword = async () => {
  setError("");
  setPasswordErrors([]);

  if (!oldPassword || !newPassword || !confirmNewPassword) {
    setError("All fields are required!");
    return;
  }

  if (newPassword !== confirmNewPassword) {
    setError("New Password and Confirm Password do not match!");
    return;
  }

  const validationErrors = getPasswordValidationErrors(newPassword);
  if (validationErrors.length > 0) {
    setPasswordErrors(validationErrors);
    return;
  }

  try {
    const token = localStorage.getItem("Token");

    if (!token) {
      setError("User not logged in");
      return;
    }

    // API Call
    const response = await axiosOrganizationInstance.put(
      "/organization/password/change",
      {
        email: userDetails.email,   // important - backend needs email
        oldPassword: oldPassword,
        newPassword: newPassword,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    console.log("Password Updated:", response.data);
    alert("Password updated successfully!");
    handleClose();

  } catch (error) {
    console.error("Password change error:", error);

    if (error.response) {
      const apiPasswordErrors = extractPasswordErrorsFromResponse(
        error.response.data
      );
      if (apiPasswordErrors.length > 0 && error.response.status === 702) {
        setPasswordErrors(apiPasswordErrors);
      } else {
        setError(error.response.data.message || "Failed to update password");
      }
    } else {
      setError("Something went wrong. Try again!");
    }
  }
};

    const openSupportWindow = () => {
      const width = 720;
      const height = 720;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const features = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`;
      const organizationName =
        localStorage.getItem("organizationName") || "Organization";

      const newWindow = window.open(
        supportUrl({ type: "organization", name: organizationName }),
        "_blank",
        features
      );

      if (!newWindow) {
        alert("Please allow popups for this website");
      }
    };

    const toggleDropdown = () => {
      setIsDropdownVisible((prev) => !prev);
    };

    const organizationName =
      localStorage.getItem("organizationName") || "Organization";

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          height: "15vh",
        }}
      >
        <div
          className="org-header-brand"
          style={{
            width: "20%",
            backgroundColor: "#C5E2FC",
            textAlign: "center",
            paddingLeft: "2vw",
            paddingRight: "1vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "10px",
            minWidth: 0,
          }}
        >
          <img
            src={organizationLogo}
            alt=""
            className="org-header-brand__logo"
          />
          <span className="org-header-brand__name" title={organizationName}>
            {organizationName}
          </span>
        </div>
        <Navbar
          style={{
            backgroundColor: "#FFFFFF",
            // backgroundColor:'red',
            borderBottom: "1px solid #D1D1D6",
            width: "78%",
            height: "15vh",
            minHeight: "15vh",
            display: "flex",
            alignItems: "center",
          }}
          expand="lg"
        >
          {/* <div className="container-white" style={{height:'15vh',display:'flex',alignItems:'center',marginTop:'-8px',backgroundColor:'white',width:'100%'}}> */}

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{ marginLeft: "auto", color: "#fff" }}
          />

          {showLinks && (
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">{!isAuthenticated ? <></> : null}</Nav>
              <Nav className="nav-collapse">
                {isAuthenticated && (
                  <>
                    <a className="support_link" onClick={openSupportWindow}>
                      Support
                    </a>
                    <div
                      className="profile-dropdown-container"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <NavDropdown
                        show={isDropdownVisible}
                        onClick={toggleDropdown}
                        id="basic-nav-dropdown"
                        align="end"
                        className="custom-dropdown-toggle"
                        title={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                              color: "#000000",
                            }}
                          >
                            <PersonCircle
                              size={24}
                              style={{ color: "#000000", marginRight: "8px" }}
                            />
                            <span style={{ color: "#000000" }}>Profile</span>
                          </span>
                        }
                      >
                        <NavDropdown.Item>
                          {userDetails?.name || "Loading..."}
                        </NavDropdown.Item>
                        <div className="dropdown-divider"></div>
                        <NavDropdown.Item>
                          {userDetails?.email || "Loading..."}
                        </NavDropdown.Item>
                        <div className="org-profile-switcher">
                          <PartnerBusinessSwitcher />
                        </div>
                        <div className="dropdown-divider"></div>
                        <NavDropdown.Item onClick={handleShow}>
                          Change Password
                        </NavDropdown.Item>
                        <div className="dropdown-divider"></div>
                        <NavDropdown.Item
                          as={Link}
                          to="https://junioreats.co/"
                          onClick={onLogout}
                        >
                          Sign Out
                        </NavDropdown.Item>
                      </NavDropdown>
                    </div>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          )}
          {/* </div> */}
        </Navbar>
        <Modal
          show={show}
          onHide={handleClose}
          className="custom-modal"
          style={{
            marginRight: "10px",
          }}
        >
          <Modal.Header>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "50vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <PasswordErrorsDisplay errors={passwordErrors} />
            {error && <p style={{ color: "red" }}>{error}</p>}
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Enter Old Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder=""
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Enter New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder=""
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder=""
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleUpdatePassword}>
              Update Password
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  return (
    <>
      {/* Conditionally render Header and Footer based on isAuthenticated */}
      {isAuthenticated && (
        <Header
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
          onLogout={handleLogout}
          showLinks={!isSupportPage}
        />
      )}

      <div
        className={
          isAuthenticated
            ? "organization-portal-outlet"
            : "organization-portal-outlet-full"
        }
      >
        <Outlet />
      </div>
    </>
  );
};

export default Organization;
